var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('resource',{attrs:{"title":"Ändern","resource":"news","resourceName":"Artikel","original":_vm.original,"attributes":[
      {
        name: 'title',
        label: 'Titel'
      },
      {
        name: 'article',
        label: 'Artikel',
        type: 'WYSIWYGSelector',
        editorToolbar: [
          { header: [false, 1, 2, 3, 4, 5, 6] },
          'bold',
          'italic',
          'underline',
          'strike',
          'code-block',
          { list: 'ordered' },
          { list: 'bullet' },
          { color: [] },
          { background: [] },
          'clean'
        ]
      },
      {
        name: 'release_time',
        label: 'Veröffentlichungsdatum',
        type: 'DateTimeSelector'
      },
      {
        name: 'read_type',
        label: 'Newscounter',
        type: 'SelectSelector'
      }
    ]}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('h4',[_vm._v("Artikel bearbeiten")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }